import ExpensePage from "@/pages/ExpensePage";
import MarketingSection from "@/components/MarketingSection";
import RoomIncome from "@/components/RoomIncome";

export default function Amministrazione() {
  return (
    <>
      <MarketingSection />
      <RoomIncome />
      <ExpensePage
        category="amministrazione"
        title="Amministrazione"
        subtitle="Spese del team A20 Travel: advertising, viaggi di lavoro e altro"
        hasSub
        catsPath="/administration-categories"
        defaultSub="ads"
        catsNote='Le categorie personalizzate confluiscono in "Amministrazione" su Dashboard, Report e Annuale.'
      />
    </>
  );
}
